
    import { Upload } from '@alifd/next';
    import type { UploadProps } from '@alifd/next/types/upload';
    import wrapper from './next-wrapper';

    export type BLProFormUploadProps =UploadProps;

    const BLProFormUpload = wrapper<BLProFormUploadProps>(Upload, 'BLProFormUpload');

    export default BLProFormUpload;
